import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import styles from './styles'
import { shortTime } from '../../utils/time'
import { StyledText, Image } from '..'
import { colors } from '../../styles'
import { ClientOnly } from '../SSRSwitch'
import NewMyListButton from '../NewMyListButton'
import { trackEvent } from '../../utils/dtmHelpers'

const Popup = ({ showPopup, onClose, popupProps }) => {
  useEffect(() => {
    document.body.style.overflow = showPopup ? 'hidden' : 'unset'
  }, [showPopup])

  const analyticsTracking = () => {
    trackEvent('viewEpisodes', { item: popupProps?.title })
  }
  const renderTitle = () => {
    if (popupProps.title.includes(':')) {
      const [firstPart, secondPart] = popupProps.title.split(':')
      return (
        <StyledText el="h3" className="cardTitle1">
          <span style={{ color: 'yellow' }}>{firstPart}:</span> {secondPart}
        </StyledText>
      )
    }
    return (
      <StyledText el="h3" className="cardTitle1">
        {popupProps.title}
      </StyledText>
    )
  }

  return (
    <div
      className={`popup ${showPopup ? 'show' : ''}`}
      onClick={onClose}
      onKeyDown={onClose}
      role="presentation"
    >
      <div
        className="popup-content"
        onClick={(e) => { e.stopPropagation() }}
        onKeyDown={(e) => { e.stopPropagation() }}
        role="presentation"
      >
        <div className="popup-image">
          <Image className="guide-image" style={{ borderRadius: '4px' }} image={popupProps.image} />
        </div>
        <div className="popup-text">
          <div className="info-wrapper">
            {renderTitle()}
            <div className="secondary-time-stamp">
              <StyledText
                className="p2"
                style={{ color: colors.secondaryText }}
              >{`${shortTime(popupProps.startTime)} until ${shortTime(popupProps.endTime)}`}
              </StyledText>
            </div>
          </div>
          {popupProps.description && (
            <StyledText
              el="p"
              className="p2"
              additionalClassName="popup-description"
            >
              {popupProps.description}
            </StyledText>
          )}
        </div>
        {popupProps.link && (
          <div className="popup-wrap">
            <div className="episodes-link">
              <Link href={popupProps.link} as={popupProps.link} target="_blank" legacyBehavior>
                <a className="live-link" onClick={analyticsTracking} target="_blank" href={popupProps.link} rel="noreferrer">
                  View episodes
                </a>
              </Link>
            </div>
            <div className="popup-mylist">
              <ClientOnly>
                <NewMyListButton
                  programme={{
                    name: popupProps.title,
                    image: popupProps.image,
                    programmeGuid: (popupProps.link !== null ? (popupProps.link).replace('/summary/', '') : ''),
                  }}
                  showText
                  addedStyles={{
                    minWidth: '170px',
                    height: '48px',
                    background: '#313131',
                    borderRadius: '4px',
                    border: 0,
                    fontWeight: '600',
                    fontSize: '16px',
                    justifyContent: 'center',
                    gap: '5px',
                    padding: '15px',
                    marginLeft: '-5px',
                  }}
                  color="#212121"
                />
              </ClientOnly>
            </div>
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
Popup.propTypes = {
  showPopup: PropTypes.bool,
  onClose: PropTypes.func,
  popupProps: PropTypes.object,
}

Popup.defaultProps = {
  showPopup: false,
  onClose: () => { },
  popupProps: {},
}
export default Popup
